const emptyFieldValidate = (field: string, name: string) => {
  let errMsg = undefined;

  if (!field) {
    errMsg = `"${name}" field shouldn't be empty.`;
  }

  if (Array.isArray(field) && field.length === 0) {
    errMsg = `You must select at least 1 ${name}.`;
  }

  return errMsg;
};

export default emptyFieldValidate;
